import { useLocation, useNavigate, useParams, useMatch, useBeforeUnload, matchPath, useSearchParams } from 'react-router-dom';
import React from 'react';
export const withRouter = (Component) => {
    const Wrapper = (props) => {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        // let match = useMatch();
        let [searchParams, setSearchParams] = useSearchParams();
        let beforeUnload = useBeforeUnload();
        return (
            <Component
                location={location}
                navigate={navigate}
                params={params}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                // match={match}
                beforeUnload={beforeUnload}
                router={{ location, navigate, params }}
                {...props}
            />
        );
    };

    return Wrapper;
};

export const getParams = (pathName, pathDesign) => {
    if (pathName && pathDesign) {
        const matchProfile = matchPath({
            path: pathDesign,
            caseSensitive: false,
            end: false,
        }, pathName);
        return (matchProfile && matchProfile.params) || {};
    }
    else {
        return {}
    }
};